export const LOGIN = '/auth/login';
export const IMG = 'http://localhost:3002';
export const REFRESH_TOKEN_URL = '/auth/refresh-token';
export const REGISTER = '/users';
export const GET_PRODUCTS = '/products';
export const GET_CATEGORIES = '/category';
export const GET_ORDERS = '/orders';
export const UPLOAD_IMAGE = '/upload';
export const ADD_NEWSLETTER = '/newsletters';